exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody,html{\n    height: 100%;\n    min-height: 100%;\n    background:#111;\n}\n", ""]);

// exports
